// extracted by mini-css-extract-plugin
export default {"code":"styles--code--1ArDi"};